import { DOCUMENTS } from '../../constants/requerimentDocuments';
import { Channels } from '@/core/constants/channelConstants';

export default {
  //when channel is PR and is an update
  applies(context, taxRegimes) {
    return (
      context.channel === Channels.WHOLESALER &&
      context.isUpdate &&
      context.taxRegime === taxRegimes.COORPORATE.value &&
      context.isPromissoryNote
    );
  },
  fields() {
    const fields = {
      [DOCUMENTS.PROMISSORY_NOTE.value]: DOCUMENTS.PROMISSORY_NOTE,
      [DOCUMENTS.LEGALREPRESENTATIVE_ID.value]:
        DOCUMENTS.LEGALREPRESENTATIVE_ID,
      [DOCUMENTS.GUARANTOR_ID.value]: DOCUMENTS.GUARANTOR_ID,
      [DOCUMENTS.SUBSCRIBER_ADDRESS.value]: DOCUMENTS.SUBSCRIBER_ADDRESS,
      [DOCUMENTS.GUARANTOR_ADDRESS.value]: DOCUMENTS.GUARANTOR_ADDRESS,
      [DOCUMENTS.TAX_STATUS_CERTIFICATE.value]:
        DOCUMENTS.TAX_STATUS_CERTIFICATE,
      [DOCUMENTS.ARTICLES_OF_INCORPORATION.value]:
        DOCUMENTS.ARTICLES_OF_INCORPORATION,
    };
    return fields;
  },
};
